import React from 'react';

const PhotoCredit = ({ credit }) => {
  if (!credit) return null;

  return (
    <a
      href={credit.url}
      target="_blank"
      rel="noopener noreferrer"
      className="absolute bottom-2 right-2 z-10 max-w-[calc(100%-1rem)] text-right text-[9px] sm:text-[10px] leading-tight text-white/70 hover:text-white focus-visible:text-white focus-visible:outline focus-visible:outline-1 focus-visible:outline-white rounded-sm transition-colors"
      style={{ textShadow: '0 1px 3px rgba(0, 0, 0, 0.6)' }}
      aria-label={`Photo : ${credit.author}, ${credit.source}. Voir la source (nouvelle fenêtre)`}
    >
      {credit.author} · {credit.source}
    </a>
  );
};

export default PhotoCredit;
